module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-700.e2fec31d.png";